/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import L from 'leaflet';
import './icons.less';
import { IAntenna } from '../MapComponent.types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createClusterCustomIcon = (cluster: any) => {
  const childCount = cluster.getChildCount();
  return L.divIcon({
    html: `
        <div style="
          width: 52px; 
          height: 52px; 
          border-radius: 50%; 
          background-color: #D4C8FA; 
          display: flex; 
          align-items: center; 
          justify-content: center; 
          color: white; 
          font-size: 16px; 
          font-weight: bold;">
          <div style="
          width: 42px; 
          height: 42px; 
          border-radius: 50%; 
          background-color: #A891F2; 
          display: flex; 
          align-items: center; 
          justify-content: center; 
          color: white; 
          font-size: 16px; 
          font-weight: bold;">
          <div style="
          width: 32px; 
          height: 32px; 
          border-radius: 50%; 
          background-color: #190952; 
          display: flex; 
          align-items: center; 
          justify-content: center; 
          color: white; 
          font-size: 16px; 
          font-weight: bold;">
          ${childCount}
          </div>
          </div>
          
        </div>`,
    iconSize: L.point(52, 52), // Size of the circular icon
    className: 'custom-cluster-icon custom-cluster-opacity  custom-cluster-visibility ', // Optional class for custom styling
  });
};

export const createPinIcon = (marker, pinDigits:number) => new L.DivIcon({
  html: `
  <div class="pin-container">
<svg width="60" height="60" viewBox="0 0 31 38" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.25 1C11.472 1.00425 7.84993 2.49568 5.17846 5.14709C2.507 7.79849 1.00429 11.3933 1 15.143C1 27.2449 13.9545 36.3848 14.5067 36.7673C14.7245 36.9188 14.9841 37 15.25 37C15.5159 37 15.7754 36.9188 15.9933 36.7673C16.5455 36.3848 29.5 27.2449 29.5 15.143C29.4957 11.3933 27.993 7.79849 25.3215 5.14709C22.6501 2.49568 19.028 1.00425 15.25 1Z" fill="#001D66" stroke="#001D66" stroke-width="2"/>
</svg>
<div class="pin-text">${marker?.uniqueKey?.slice(-pinDigits) ?? ''}</div>
</div>
  `,
  iconSize: [60, 60], // Adjust size based on SVG dimensions
  iconAnchor: [30, 60],
  className: `custom-pin-icon custom-pin-opacity custom-marker-${marker?.uniqueKey} custom-pin-visibility `, // Optional class for custom styling
});

export const createDotIcon = (point) => L.circleMarker(point, {
  radius: 4,
  color: 'red',
  fillColor: 'red',
  fillOpacity: 1,
});

export const createAntennaIcon = (antenna: IAntenna) => {
  const name = antenna.expanderPort?.length > 0 ? `${antenna?.port}:${antenna?.expanderPort}` : antenna?.port;
  return new L.DivIcon({
    html: `
      <div style="display: flex; flex-direction: column; align-items: center; gap:5px">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="20" height="20" rx="2" fill="#EBE6FF" fill-opacity="0.7"/>
          <path d="M2 2.52933L18 17.5009" stroke="#5D30F0" stroke-width="1.5" stroke-linecap="round" stroke-dasharray="2 2"/>
          <path d="M2 17.4404L18 2.52939" stroke="#5D30F0" stroke-width="1.5" stroke-linecap="round" stroke-dasharray="2 2"/>
        </svg>
        <span class="antenna-label" style=" background-color: #EBE5FF; font-weight: 600; font-size: 10px; border: 2px solid #5D30F0; border-radius: 8px; padding: 4px; text-wrap: nowrap;">${name}</span>
      </div>
    `,
    iconSize: [31, 39], // Adjust size based on SVG dimensions
    iconAnchor: [8, 12],
    className: `custom-pin-icon custom-antenna-opacity custom-antenna-visibility custom-antenna-${antenna?.id}`,
  });
};
